var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxPowerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 56.5003C43.762 56.5003 53.3327 46.9296 53.3327 35.167C53.3327 26.2336 47.8073 18.5776 39.9993 15.4043V21.3323C44.7727 24.1056 47.9993 29.2603 47.9993 35.167C47.9993 43.991 40.8233 51.167 31.9993 51.167C23.1753 51.167 15.9993 43.991 15.9993 35.167C15.9993 29.2603 19.226 24.103 23.9993 21.3323V15.4043C16.1913 18.5776 10.666 26.2336 10.666 35.167C10.666 46.9296 20.2367 56.5003 31.9993 56.5003Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.334 5.83398H34.6673V32.5006H29.334V5.83398Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPowerOff);
export default __webpack_public_path__ + "static/media/bx-power-off.0ffa32b16622b1fbb5664cdb0108f172.svg";
export { ForwardRef as ReactComponent };